<template>
    <div class="c2p-overview" v-if="isClick2PayPayment">
        <div class="c2p-overview__container">
            <div class="c2p-overview__info">
                <div class="c2p-overview__icon">
                    <img :src="artUri" alt="card image" />
                </div>
    
                <div class="c2p-overview__card-info" tabindex="0">
                    <div class="c2p-overview__last-digits">
                        <div>&bull;&bull;&bull;&bull;</div>
                        {{ cardPanLastFour }}
                    </div>
                    <span>{{ maskedFullName }}</span>
                </div>
            </div>


            <div class="c2p-overview__price">
                <img src="@/assets/img/c2p-logo.svg" alt="Click to pay" />
                <p tabindex="0">
                    {{ installments || 1 }} x
                    <span v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import translationParameterHelper from '@/config/lang/helpers/translationParameterHelper.js';

export default {
	components: {

	},

	computed: {
		...mapGetters({
			installments: 'payment/getInstallmentNumberOfPayments',
			installmentPrice: 'payment/getFormattedInstallmentPrice',
			paymentType: 'payment/getSelectedPaymentTypeId',
		}),
		numberOfInstallments: {
			get: (self) =>
				self.$store.getters['payment/getInstallmentNumberOfPayments'],
			set(value) {
				this.$store.commit('payment/setNumberOfInstallments', value);
			},
		},

		maskedFullName() {
			return this.$store.state.clickToPayPayment.checkoutResponse.maskedFullName;
		},

		cardPanLastFour() {
			return this.$store.state.clickToPayPayment.checkoutResponse
				.cardPanLastFour;
		},

		artUri() {
			return this.$store.state.clickToPayPayment.checkoutResponse
				.cardArtUri;
		},

		paymentMethodImage: (self) =>
			self.selectedPaymentMethod
				? self.selectedPaymentMethod.Image
				: null,

		isClick2PayPayment: (self) => self.$store.state.payment.PaymentType === 100,
	},

	methods: {
		getPaymentMethodTranslationParameterName() {
			return translationParameterHelper.getPaymentMethodTranslationParameterName(
				this.selectedPaymentMethod.PaymentType
			);
		},
	},
};
</script>

<style lang="scss" scoped>
    .c2p-overview {

        &__container {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &__icon {
            margin-right: 12px;
            
            @media screen and (min-width: 1025px) {
              margin-right: 20px;
            }

            img {
              width: 32px;
              height: 21px;
            }
        }

        &__info {
            display: flex;
            align-items: center;
        }

        &__card-info {
            span {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000;
            }
        }

        &__last-digits {
            display: flex;
            align-items: center;
            font-size: 16px;
            line-height: 24px;
            font-weight: 500;
            color: #000;
            margin-bottom: 2px;

            div:first-child {
                margin-right: 2px;
            }
        }

        &__price {
            text-align: right;

            img {
              margin-bottom: 12px;
              line-height: 24px;
            }

            p {
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
              margin: 0;
            }

            & > span {
              display: block;
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
              margin-bottom: 12px;
            }
        }

    }
</style>
